// extracted by mini-css-extract-plugin
export default {"navigation_list":"navbar_navigation_list__BMZQ3","link":"navbar_link__SZX2j","active":"navbar_active__EPZsy","button_wrapper":"navbar_button_wrapper__q7wRN"};